import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/internal/operators';
import { AuthService } from '../service/auth.service';
import { AlertService } from './alert.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    public auth: AuthService,
    public alert: AlertService,
    private router: Router
  ) {}

  /**
   * intercept all XHR request
   * @param request
   * @param next
   * @returns {Observable<A>}
   */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const tokenType = localStorage.getItem('token_type');
    const accessToken = localStorage.getItem('access_token');
    if (tokenType && accessToken) {
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          Authorization: `${tokenType} ${accessToken}`
        }
      });
    }

    /**
     * continues request execution
     */
    return next.handle(request).pipe(
      map((event) => {
        if(event instanceof HttpResponse) {
          if(event.body && JSON.stringify(event.body).indexOf('Unauthenticated') >= 0) {
            // writeLog('event.body', event.body);
            throw(new HttpErrorResponse({status: 401}));
          }
        }
        return event;
      }),
      catchError((error, caught) => {
        // intercept the respons error and displace it to the console
        this.handleAuthError(error);
        return of(error);
      }) as any
    );
  }

  /**
   * manage errors
   * @param err
   * @returns {any}
   */
  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    // handle your auth error or rethrow

    if (err.status === 401) {
      if (this.router.url.indexOf('login') >= 0) {
        throw err;
      }

      // navigate & delete cookies
      this.router.navigate([`/logout`]);

      this.alert.alert({
        title: 'Sorry!',
        message: 'Your session has ended.',
      });

      return of(err.message);
    }
    // else logout and redirect to login page if 403
    else if (err.status === 403) {
      if (this.router.url.indexOf('login') >= 0) {
        throw err;
      }

      // navigate & delete cookies
      this.router.navigate([`/logout`]);

      this.alert.alert({
        title: 'Sorry!',
        message: err.error.message,
      });

      return of(err.message);
    }
    throw err;
  }
}
